import styled from "styled-components";

const A = styled.div`
    backdrop-filter: blur(1px);
    background: #0006;
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 100;
`;

const B = styled.div`
    background: #fff;
    max-height: 50vh;
    max-width: 50vw;
    top: 25vh;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
`;

export default function Modal(props) {
    const { children, isOpen, onClose } = props;

    if (!isOpen) return undefined;

    function x(event) {
        if (event.target.classList.contains("close")) onClose();
    }

    return (
        <A className="close" onClick={ x }>
            <B>
                { children }
            </B>
        </A>
    );
}
